const actions = {
  GET_MY_ACCOUNT_DETAILS: "getMyAccountDetails",
  UPDATE_NOTIFICATION_SETTINGS: "updateAccountNotificationSettings",
  POST_CARD_NUMBER_TO_RESET_PASSWORD_SEND_SMS:
    "postCardNumberToResetPasswordSendSMS",
  POST_NEW_PASSWORD_DATA_TO_CHANGE_PASSWORD:
    "postNewPasswordDataToChangePassword"
};

export default actions;
